import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormArray, FormControl, Validators } from '@angular/forms';
import {
  LocationOfDevicesUnrelatedToRoadStageForm,
  LocationOfDevicesUnrelatedToRoadStageFormValue,
  toStageFormValue
} from './location-of-devices-unrelated-to-road-stage.form';
import {
  LocationDecisionAppEntityLocationDecisionWrite,
  RoadOccupationAppEntityApplicationRead, RoadOccupationPurposeFeeAppEntityDictionaryRoadOccupationPurposeFee
} from '../../../../../../../openapi';
import {RoadOccupationStageForm} from "../../../../common/occupation-data-section/forms/road-occupation-stage.form";

export function occupationsToFormValue(occupations: Array<RoadOccupationAppEntityApplicationRead>): LocationOfDevicesUnrelatedToRoadOccupationFormValue[] {
  return occupations
    .sort((a, b) => (b?.ordinalNumber || 0) - (a?.ordinalNumber || 0))
    .map(occupation => ({
      id: occupation?.uuid || '',
      deviceType: occupation?.deviceType || '',
      stages: [...occupation?.stages || []]
        .sort((a, b) => (b?.ordinalNumber || 0) - (a?.ordinalNumber || 0))
        .map(v => toStageFormValue(v)) || [],

      locationDecisions: occupation?.locationDecisions?.map(v => ({
        decisionNumber: v.decisionNumber,
        decisionDate: v.decisionDate
      })) || []
    }));
}

export interface LocationOfDevicesUnrelatedToRoadOccupationFormValue {
  id: string;
  deviceType: string;
  stages: LocationOfDevicesUnrelatedToRoadStageFormValue[];
  locationDecisions: LocationDecisionAppEntityLocationDecisionWrite[];
}

@Injectable()
export class LocationOfDevicesUnrelatedToRoadOccupationForm extends AppForm {
  constructor() {
    super({
      id: new FormControl('', { nonNullable: true }),
      deviceType: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      locationDecisions: new FormControl([], {
        nonNullable: true,
        validators: [Validators.minLength(1), Validators.maxLength(255)]
      }),
      stages: new FormArray([
        new LocationOfDevicesUnrelatedToRoadStageForm()
      ])
    });
  }

  public get locationDecisions(): FormControl {
    return this.get('locationDecisions') as FormControl;
  }

  public addStage(fees: RoadOccupationPurposeFeeAppEntityDictionaryRoadOccupationPurposeFee[]): void {
    const f = new LocationOfDevicesUnrelatedToRoadStageForm();
    f.createPurposeFeesForms(fees, []);
    this.stages.push(f);
  }

  public removeStage(i: number): void {
    this.stages.removeAt(i);
  }

  public get stages(): FormArray {
    return this.get('stages') as FormArray;
  }

  public getStageForms(): LocationOfDevicesUnrelatedToRoadStageForm[] {
    return this.stages.controls as LocationOfDevicesUnrelatedToRoadStageForm[];
  }

  public override patchFormValues(data: {
    value: LocationOfDevicesUnrelatedToRoadOccupationFormValue | null;
    purposeFeeCollection: RoadOccupationPurposeFeeAppEntityDictionaryRoadOccupationPurposeFee[];
  }): void {
    super.patchFormValues(data.value);

    this.stages.clear();
    (data.value?.stages || []).forEach(stage => {
      const sf = new LocationOfDevicesUnrelatedToRoadStageForm();
      sf.patchFormValues({
        ...stage
      });
      sf.createPurposeFeesForms(data.purposeFeeCollection, stage.purposeFees);
      this.stages.push(sf);
    });

    if (!this.stages.length) {
      const sf = new LocationOfDevicesUnrelatedToRoadStageForm();
      sf.createPurposeFeesForms(data.purposeFeeCollection, []);
      this.stages.push(sf);
    }
  }

  public get values(): LocationOfDevicesUnrelatedToRoadOccupationFormValue {
    return {
      ...this.value,
      stages: this.getStageForms().map(sf => sf.values)
    };
  }
}
